import { faArrowAltCircleDown } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const ButtonArrow = () => {
  const handleScroll = () => {
    const headerHeight = document.getElementById("header").clientHeight;
    window.scrollBy({
      top: window.innerHeight - headerHeight,
      behavior: "smooth",
    });
  };

  return (
    <button
      id="arrow-btn"
      className="btn btn-transparent text-light cursor-pointer"
      onClick={handleScroll}
    >
      <FontAwesomeIcon className="fs-1" icon={faArrowAltCircleDown} />
    </button>
  );
};

export default ButtonArrow;
